import { Component, Element, Event, Prop } from '@stencil/core';
import type { ComponentInterface, EventEmitter } from '@stencil/core';

@Component({
	tag: 'app-overlay',
	styleUrl: 'overlay.scss'
})
export class Overlay implements ComponentInterface {
	@Element() root: HTMLElement;

	@Prop({ reflect: true, mutable: true }) active = false;
	@Prop({ reflect: true }) underNextSibling = false;
	@Prop() clickToDismiss = true;
	@Prop() escapeToDismiss = true;

	// detail shows what is being dismissed
	// strange build error prevents the type from being set to Element
	@Event() overlayDismissed: EventEmitter<any>;

	#dismiss() {
		this.active = false;
		this.overlayDismissed.emit(
			// either the next sibling or the whole body is being dismissed
			this.underNextSibling
				? this.root.nextElementSibling
				: document.body
		);
	}

	componentWillLoad() {
		this.root.addEventListener('click', () => {
			if (this.clickToDismiss)
				this.#dismiss();
		});

		addEventListener('keydown', ({ key }) => {
			if (this.escapeToDismiss && key === 'Escape')
				this.#dismiss();
		});
	}
}
